import * as d3 from 'd3';
import { ElementRender } from './ElementeRenderer';
import { ItemFormat } from '../interfaces';
import { RoundingHelper } from '../../..';

export class Labels extends ElementRender {

    constructor(selection: d3.Selection<any>) {
        super(selection, 'value-labels');
    }

    render(data: ItemFormat[]) {
        const ratio = this.ratio() || 1;
        const container = this.container()
            .classed('hidden-group', !this.visible());
        container.selectAll('g.value-label')
            .data(data);
        const databound = container
            .selectAll('g.value-label')
            .data(data);
        databound.exit()
            .remove();
        const enterLabelGroup = databound
            .enter()
            .append('g')
            .classed('value-label', true);
        enterLabelGroup.append('rect');
        enterLabelGroup.append('text')
            .style({ 'text-anchor': 'middle' });

        //update
        const magicCoefficient = 4.2 * ratio;
        const margin = 6 * ratio;
        databound
            .transition()
            .attr('transform', (d, i) => {
                let x = d.x + d.width / 2;
                const value = d.item.value;
                let y = d.y - (value > 0 ? 5 : -15) * ratio;
                // label should always be fully visible
                y = Math.max(y, 15 * ratio);
                // also from bottom
                const plotHeight = this.height() - 10 * ratio;
                y = y > plotHeight ? plotHeight : y;

                x = RoundingHelper.notNaN(x, 0);
                y = RoundingHelper.notNaN(y, 0);
                return `translate(${x},${y})`;
            });


        const rectHeight = 15 * ratio;
        databound.select('rect')
            .attr('height', rectHeight)
            .attr('width', d => d.item.formattedValue.length * magicCoefficient + margin)
            .attr('transform', d => `translate(${-d.item.formattedValue.length * magicCoefficient / 2 - margin / 2},${-11 * ratio})`);

        databound
            .select('text')
            .style('fill', d => d.color || d.item.color)
            .text(d => d.item.formattedValue);
    }
}